// B2B Products and Pricing Data

export const businessTypes = [
  { id: 'restaurant', name: 'مطعم', nameEn: 'Restaurant', icon: '🍽️' },
  { id: 'supermarket', name: 'سوبرماركت', nameEn: 'Supermarket', icon: '🛒' },
  { id: 'trader', name: 'تاجر', nameEn: 'Trader', icon: '🏪' },
  { id: 'distributor', name: 'موزّع', nameEn: 'Distributor', icon: '🚚' }
];

export const products = [
  {
    id: 'bread_large',
    name: 'خبز كبير',
    nameEn: 'Large Bread',
    unit: 'صندوق',
    unitEn: 'box',
    unitsPerBox: 10,
    unitDescription: '10 ربطات/صندوق',
    price: 25.00,
    image: '🍞'
  },
  {
    id: 'bread_small',
    name: 'خبز صغير',
    nameEn: 'Small Bread',
    unit: 'صندوق',
    unitEn: 'box',
    unitsPerBox: 15,
    unitDescription: '15 ربطة/صندوق',
    price: 20.00,
    image: '🥖'
  },
  {
    id: 'bread_brown',
    name: 'خبز أسمر',
    nameEn: 'Brown Bread',
    unit: 'صندوق',
    unitEn: 'box',
    unitsPerBox: 15,
    unitDescription: '15 ربطة/صندوق',
    price: 22.00,
    image: '🍞'
  },
  {
    id: 'bread_tannour',
    name: 'خبز التنور',
    nameEn: 'Tannour Bread',
    unit: 'ربطة',
    unitEn: 'bundle',
    price: 3.50,
    image: '🫓'
  },
  {
    id: 'bread_saj',
    name: 'خبز الصاج',
    nameEn: 'Saj Bread',
    unit: 'ربطة',
    unitEn: 'bundle',
    price: 3.00,
    image: '🫓'
  },
  {
    id: 'samoon',
    name: 'صمون',
    nameEn: 'Samoon',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 0.80,
    image: '🥐'
  },
  {
    id: 'hamburger',
    name: 'همبرغر',
    nameEn: 'Hamburger Bun',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 0.70,
    image: '🍔'
  },
  {
    id: 'croissant_cheese',
    name: 'كروصان جبنة',
    nameEn: 'Cheese Croissant',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 1.50,
    image: '🥐'
  },
  {
    id: 'croissant_zaatar',
    name: 'كروصان زعتر',
    nameEn: 'Zaatar Croissant',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 1.50,
    image: '🥐'
  },
  {
    id: 'croissant_chocolate',
    name: 'كروصان شوكولا',
    nameEn: 'Chocolate Croissant',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 1.80,
    image: '🥐'
  },
  {
    id: 'kaak_dates',
    name: 'كعك تمر',
    nameEn: 'Date Kaak',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 1.20,
    image: '🥯'
  },
  {
    id: 'cake',
    name: 'كاتو',
    nameEn: 'Cake',
    unit: 'قطعة',
    unitEn: 'piece',
    price: 2.50,
    image: '🍰'
  }
];

// Products available for each business type with quick select options
export const businessProducts = {
  restaurant: [
    { productId: 'bread_large', quickSelect: [3, 5, 7, 10] },
    { productId: 'bread_small', quickSelect: [3, 5, 7, 10] },
    { productId: 'bread_saj', quickSelect: [25, 50, 75, 100] }
  ],
  supermarket: [
    { productId: 'bread_large', quickSelect: [5, 10, 15, 20] },
    { productId: 'bread_small', quickSelect: [3, 4, 5, 10] },
    { productId: 'bread_brown', quickSelect: [1, 2, 3, 5] },
    { productId: 'bread_tannour', quickSelect: [] },
    { productId: 'bread_saj', quickSelect: [] },
    { productId: 'samoon', quickSelect: [] },
    { productId: 'hamburger', quickSelect: [] },
    { productId: 'croissant_cheese', quickSelect: [] },
    { productId: 'croissant_zaatar', quickSelect: [] },
    { productId: 'croissant_chocolate', quickSelect: [] },
    { productId: 'kaak_dates', quickSelect: [] },
    { productId: 'cake', quickSelect: [] }
  ],
  distributor: [
    { productId: 'bread_large', quickSelect: [20, 30, 60, 90] },
    { productId: 'bread_small', quickSelect: [10, 15, 20, 50] },
    { productId: 'bread_brown', quickSelect: [10, 20, 30] },
    { productId: 'bread_tannour', quickSelect: [] },
    { productId: 'bread_saj', quickSelect: [] },
    { productId: 'samoon', quickSelect: [] },
    { productId: 'hamburger', quickSelect: [] },
    { productId: 'croissant_cheese', quickSelect: [] },
    { productId: 'croissant_zaatar', quickSelect: [] },
    { productId: 'croissant_chocolate', quickSelect: [] },
    { productId: 'kaak_dates', quickSelect: [] },
    { productId: 'cake', quickSelect: [] }
  ],
  trader: [
    { productId: 'bread_large', quickSelect: [20, 30, 60, 90] },
    { productId: 'bread_small', quickSelect: [10, 15, 20, 50] },
    { productId: 'bread_brown', quickSelect: [10, 20, 30] },
    { productId: 'bread_tannour', quickSelect: [] },
    { productId: 'bread_saj', quickSelect: [] },
    { productId: 'samoon', quickSelect: [] },
    { productId: 'hamburger', quickSelect: [] },
    { productId: 'croissant_cheese', quickSelect: [] },
    { productId: 'croissant_zaatar', quickSelect: [] },
    { productId: 'croissant_chocolate', quickSelect: [] },
    { productId: 'kaak_dates', quickSelect: [] },
    { productId: 'cake', quickSelect: [] }
  ]
};

export const orderStatuses = [
  { id: 'pending', name: 'جديد', nameEn: 'New', color: 'yellow' },
  { id: 'confirmed', name: 'مؤكد', nameEn: 'Confirmed', color: 'blue' },
  { id: 'preparing', name: 'تحت التجهيز', nameEn: 'Preparing', color: 'orange' },
  { id: 'completed', name: 'مكتمل', nameEn: 'Completed', color: 'green' },
  { id: 'cancelled', name: 'ملغي', nameEn: 'Cancelled', color: 'red' }
];
